import { archiveTypes, selectValues } from "./selectvalues";
import { getValueOrDefault } from "./utilitiesmodule";

export const labels = {

    "useArchiveCompression": 'ARCHIVE - USE ARCHIVE COMPRESSION',
    "useArchiveFileCustomName": 'ARCHIVE - USE FILE CUSTOM NAME',
    "archiveFileCustomName": 'ARCHIVE - FILE CUSTOM NAME',
    "useArchivePassword": 'ARCHIVE - USE PASSWORD',
    "archivePassword": 'ARCHIVE - PASSWORD',
    "protectionType": "ARCHIVE - PROTECTION TYPE",
    "pathsInArchive": "ARCHIVE - PATHS IN ARCHIVE",

    "backupMode": 'BACKUP - MODE',
    "backupType": 'BACKUP - TYPE',
    "nCopies": 'BACKUP - NUMBER OF COPIES',
    "nOfCopies": 'BACKUP - NUMBER OF COPIES',
    "verifyBackup": 'BACKUP - VERIFY BACKUP',

    "specifiedExtensions": "FILTERS - SPECIFIED EXTENSIONS",
    "extensionsFilterAction": "FILTERS - INCLUDE/EXCLUDE EXTENSIONS",
    "useFileSizeFilter": "FILTERS - FILE SIZE FILTER - ENABLED",
    "fileSizeFilterCompare": "FILTERS - FILE SIZE FILTER - COMPARATOR",
    "fileSizeFilterAction": "FILTERS - FILE SIZE FILTER - ACTION",
    "fileSize": "FILTERS - FILE SIZE FILTER - FILE SIZE (in MB)",

    "excludedPaths": "EXCLUSIONS - EXCLUDED PATHS",
    "excludeSubFolders": "EXCLUSIONS - EXCLUDE SUB FOLDERS",

    "disableDasdIo": "ENABLE I/O BOUNDARY CHECKS BY THE FILE SYSTEM",

    "autoAddNewItems": "ADD NEW ITEMS AUTOMATICALLY",
    "useNativeComp": "USE NATIVE COMPRESSION",

    "enableAppend": "APPEND TEXT AND/OR DYNAMIC VARIABLES TO THE BACKUP FILE NAME",
    "appendTextBkp": "APPEND TEXT BACKUP",
    "singleComp": "CREATE .ZIP FILE FOR EACH SINGLE DATABASE",
    "backupLog": "BACKUP THE TRANSACTION LOG",
    "shrinkLog": "SHRINK THE TRANSACTION LOG AFTER THE BACKUP",
    "alterDbRecModel": "ALTER THE DATABASE RECOVERY MODE TO 'SIMPLE' IF NECESSARY",
    "appName": "APPLICATION NAME",
    "useModernAuth": "USE MODERN AUTHENTICATION",
    "useWinAuth": "USE WINDOWS AUTHENTICATION",
    "useTcpIpNetLib": "USE 'TCP/IP NET LIBRARY'",
    "usePersistSecInfo": "USE 'PERSIST SECURITY INFO'",
    "useIntSecSSPI": "USE 'INTEGRATED SECURITY SSPI'",
    "useTrustConn": "USE TRUSTED CONNECTION",
    "useEncConn": "USE ENCRYPTED CONNECTION",
    "usePop3": "POP3 - ENABLED",
    "popUsername": "POP3 - USERNAME",
    "popPassword": "POP3 - PASSWORD",
    "popServer": "POP3 - SERVER",
    "popPort": "POP3 - PORT",

    "nThreads": "NUMBER OF THREADS",
    "passiveMode": "USE PASSIVE MODE",
    "nDownloadThreads": "NUMBER OF DOWNLOAD THREADS",
    "buffer": "BUFFER SIZE",

    "createPCNameFolder": "CREATE FOLDER WITH PC NAME",
    "rct": "BACKUP RCT (RESILIENT CHANGE TRACKING)",

    "NumThreads": "NUMBER OF THREADS",
    "NumDownloadThreads": "NUMBER OF DOWNLOAD THREADS",

    "VmName": "VIRTUAL MACHINE NAME",
    "VmGuid": "VIRTUAL MACHINE ID",
    "Source_iterationFolder": "ITERATION FOLDER",

    "Source_type": "TYPE",
    "Destination_customFolder": "DESTINATION CUSTOM FOLDER",

    "RESTORE_index": "NUMBER OF THE SELECTED COPY",

    "elementName": "VIRTUAL MACHINE NAME",
    "incompCount": "INCOMPATIBILITIES COUNT",
    
    "objLock_enabled": "Object lock enabled",
    "objLock_mode": "Protection mode",
    "objLock_retainDays": "Retention period (days)",
    "useVirtuaHosting" : "Use virtual hosting"
}

function getLabelFrom(propName) {
    //ricavo la label
    let label = labels[propName];

    if (label != undefined) {
        return label;
    }

    // Se non trovo la label corrispondente, 
    // la ricavo staccando le parole dal nome della proprietà
    label = propName
        .replace(/_/g, " ")// sostituisce underscore con spazio
        .replace(/([a-z])([A-Z])/g, "$1 $2")// inserisce spazio prima delle maiuscole
        .replace(/([A-Z])([A-Z][a-z])/g, "$1 $2")// gestisce casi tipo "HTMLParser" → "HTML Parser"
        .toUpperCase();

    console.debug("label di '" + propName + "' ricavata : " + label);
    return label;

}

//Dall'oggetto passato ritorna un oggetto le cui proprietà solo le label e i valori rimangono tali. Si modificano solamente i booleani in yes/no
export function getFriendlyObject(obj) {

    if ([undefined, null, "undefined", "null", ""].includes(obj)) {

        return [
            ["Warning"], { "Warning": "Data not found" }
        ];
    }

    var friendlyObj = {};
    var propsNames = Object.keys(obj);
    var propLabel, propValue;
    propsNames.forEach(p => {

        if (propsToExclude.includes(p))
            return;

        //ricavo la label
        propLabel = getLabelFrom(p);

        propValue = getValueOrDefault(obj[p], null);
        if (propValue == null) {
            return;
        }

        //Devo sistemare alcuni valori
        if (propValue.toString().toLowerCase() == "true") {
            propValue = "Yes";
        }

        if (propValue.toString().toLowerCase() == "false") {
            propValue = "No";
        }


        switch (p) {
            case "protectionType":
                if (!obj.useArchiveCompression) return;
                propValue = selectValues.protectionTypes[propValue]; // propValue è l'indice del valore
                break;

            case "pathsInArchive":
                if (!obj.useArchiveCompression) return;
                propValue = selectValues.pathsInArchive[propValue];
                break;

            case "backupType":
                propValue = selectValues.backupTypes[propValue];
                break;

            case "fileSizeFilterAction":
                if (!obj.useFileSizeFilter) return;
                propValue = selectValues.fileSizeFilterAction[propValue];
                break;

            case "fileSizeFilterCompare":
                if (!obj.useFileSizeFilter) return;
                propValue = selectValues.fileSizeFilterCompare[propValue];
                break;

            case "fileSize":
                if (!obj.useFileSizeFilter) return;
                break;

            case "extensionsFilterAction":
                if (obj.specifiedExtensions == "") return;
                propValue = selectValues.extensionsFilterAction[propValue];
                break;

            case "excludedPaths":
                //propValue = {
                //    mainPath : [nodo1, nodo2, ...],
                //    ...
                //}
                var mainPath_excludedNodes;
                if (typeof propValue == 'object') {
                    mainPath_excludedNodes = propValue
                    if (Object.keys(mainPath_excludedNodes).length == 0(mainPath_excludedNodes)) {
                        return;
                    }

                } else if (propValue == "" || propValue.contains("{}")) {
                    return;
                } else {
                    mainPath_excludedNodes = JSON.parse(propValue.toString());
                }

                propValue = Object.values(mainPath_excludedNodes)
                    .map(nodes => nodes.map(node => node.path))
                    .flat().join("\n");
                break;

            case "archiveType":
                if (!obj.useArchiveCompression)
                    return;
                propValue = archiveTypes[propValue];
                break;

            case "useArchiveFileCustomName":
                return;
            case "useArchivePassword":
                return;
            case "restoreType":
                if (obj[p] == 0) {
                    propValue = "Restore single items";
                }

                if (obj[p] == 1) {
                    propValue = "Recreate full copy from backup";
                }

                if (obj[p] == 2) {
                    propValue = "Recreate a specific copy from backup";
                }

                break;
            default:
                // Se non è stata abilitata la compressione zip, non mostro le sue informazioni
                if (!obj["useArchiveCompression"] && [
                    "archiveFileCustomName",
                    "useArchivePassword",
                ].includes(p)) {
                    return;
                }

                // if (!obj["useArchiveFileCustomName"] && p == "archiveFileCustomName")
                //     return;

                // if (!obj["useArchivePassword"] && p == "archivePassword")
                //     return;


                if (p == "port" && obj.port == 0)
                    return;
                break;
        }


        if (propValue != null) {

            friendlyObj[propLabel] = propValue;
        }
    });

    var orderedProperties = Object.keys(friendlyObj);
    orderedProperties.sort((a, b) => a.localeCompare(b));
    return [orderedProperties, friendlyObj];
}

const propsToExclude = [
    "id",
    "id_master_account",
    "access_token",
    "refresh_token",
    "status",
    "token",
    "type",
    "options",
    "accountSessionId",
    "id_service_account",
    "svcId",
    "Source_idSA",
    "Destination_idSA",
    "password",
    "archivePassword",
    "popPassword",
    "objID",
    "driveID",
    "userID",
    "lastTestPC",
    "client_secret",
    "id_repository",
    "id_license",
    "id_job",
    "dbSource",
    "downloadSource",
    "driveImgSource",
    "esxiSource",
    "exchangeSource",
    "folderSource",
    "hvSource",
    "networkSource",
    "archivePassword_repeat",
    "includeArchiveMailbox",
    "crypted",
    "inserted_at",
    "updated_at",
    "syncronize", //non implementato
    "items",
    "Destination_idsAccounts",
    "instanceID",
    "restoreGuid",

    //Campi non utilizzati in Exchange
    "truncateExchangeLogs",
    "badItemsLimit"
];